export default __webpack_public_path__ + "static/Sasha-4a933372782737709534c616bac2e47a.jpg";